import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getVerificationIndividual3MasterReferenceData = createAsyncThunk(
  'stop/getVerificationIndividual3MasterReferenceData',
  async (params) => {
    const { url, payload, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .post(url, payload, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });
    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const verificationIndividual3MasterReferenceSlice = createSlice({
  name: 'stop/verificationIndividual3MasterReferenceSlice',
  initialState: null,
  reducers: {
    resetVerificationIndividual3MasterReference: () => null,
  },
  extraReducers: {
    [getVerificationIndividual3MasterReferenceData.fulfilled]: (
      state,
      action
    ) => action.payload,
  },
});

export const { resetVerificationIndividual3MasterReference } =
  verificationIndividual3MasterReferenceSlice.actions;

export default verificationIndividual3MasterReferenceSlice.reducer;
